export default __webpack_public_path__ + "images/SARPA.b66e1d7.png";